import { ALL_ENGINES, engineCeiling, engineLabel } from '@/lib/format'
import type { EngineId, Scores } from '@/lib/types'

export function PlatformBreakdown({
  scores,
  totalQueries,
}: {
  scores: Partial<Scores>
  totalQueries: number
}) {
  const ceiling = engineCeiling(totalQueries)
  const perEngine = scores.perEngine ?? {}
  return (
    <div className="p-6 rounded-xl border border-border bg-card">
      <h3 className="text-sm font-semibold mb-1">Platform Breakdown</h3>
      <p className="text-xs text-muted-foreground mb-4">
        Visibility points per AI model
      </p>
      <div className="space-y-3">
        {ALL_ENGINES.map((id: EngineId) => {
          const v = perEngine[id]
          if (typeof v !== 'number') {
            const isComingSoon = id === 'google'

            return (
              <div key={id}>
                <div className="flex items-baseline justify-between text-sm mb-1.5">
                  <span className="font-medium">{engineLabel(id)}</span>
                  <span className="text-muted-foreground tabular-nums">
                    {isComingSoon ? (
                      <span className="rounded-full border border-border bg-muted px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide">
                        Coming soon
                      </span>
                    ) : (
                      'n/a'
                    )}
                  </span>
                </div>
                {!isComingSoon && (
                  <div className="h-1.5 rounded-full bg-secondary overflow-hidden">
                    <div
                      className="h-full bg-primary transition-all duration-700"
                      style={{ width: '0%' }}
                    />
                  </div>
                )}
              </div>
            )
          }
          const pct = ceiling > 0 ? (v / ceiling) * 100 : 0
          return (
            <div key={id}>
              <div className="flex items-baseline justify-between text-sm mb-1.5">
                <span className="font-medium">{engineLabel(id)}</span>
                <span className="text-muted-foreground tabular-nums">
                  <span className="text-foreground">{Math.round(v)}</span> /{' '}
                  {ceiling}
                </span>
              </div>
              <div className="h-1.5 rounded-full bg-secondary overflow-hidden">
                <div
                  className="h-full bg-primary transition-all duration-700"
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
